/**
 * Resolves iframe URL params for exterior/interior 360 (spin JSON is always the data source).
 *
 * - spin: legacy — load spin data, show both products when present; exterior at spin position, interior after exterior.
 * - ext360 / int360: independent carousel slots and visibility (still loads spin.json).
 * - type360: legacy filter when using spin-only mode (ext | int).
 */
export const resolveSpin360Config = (params = {}) => {
  const type360 = (params?.type360 || "").toLowerCase();
  const isType360Requested = type360 === "ext" || type360 === "int";
  const spinPos = Number(params?.spin) || 0;
  const ext360Pos = Number(params?.ext360) || 0;
  const int360Pos = Number(params?.int360) || 0;
  const useSplit360 = ext360Pos > 0 || int360Pos > 0;
  const needsSpinFetch =
    spinPos > 0 || ext360Pos > 0 || int360Pos > 0 || isType360Requested;

  if (useSplit360) {
    return {
      type360,
      isType360Requested,
      needsSpinFetch,
      useSplit360: true,
      showExterior: ext360Pos > 0,
      showInterior: int360Pos > 0,
      exteriorPosition: ext360Pos,
      interiorPosition: int360Pos,
      legacyIntAfterExt: false,
    };
  }

  if (spinPos > 0 || isType360Requested) {
    const position = spinPos > 0 ? spinPos : 1;
    return {
      type360,
      isType360Requested,
      needsSpinFetch: true,
      useSplit360: false,
      showExterior: type360 !== "int",
      showInterior: type360 !== "ext",
      exteriorPosition: position,
      interiorPosition: position,
      legacyIntAfterExt: true,
    };
  }

  return {
    type360,
    isType360Requested,
    needsSpinFetch: false,
    useSplit360: false,
    showExterior: false,
    showInterior: false,
    exteriorPosition: 0,
    interiorPosition: 0,
    legacyIntAfterExt: false,
  };
};

/** Legacy spin-only: keep interior slide immediately after exterior. */
export const orderCarousel360Items = (items, { legacyIntAfterExt } = {}) => {
  if (!legacyIntAfterExt) return items;
  const next = [...items];
  const idx360 = next.findIndex((item) => item.type === "360");
  const idx360Int = next.findIndex((item) => item.type === "360Int");
  if (idx360 !== -1 && idx360Int !== -1 && idx360Int !== idx360 + 1) {
    const [intItem] = next.splice(idx360Int, 1);
    next.splice(idx360 + 1, 0, intItem);
  }
  return next;
};

export const applySpinPayloadToMediaData = (mediaData, spinPayload, spin360) => {
  if (!spinPayload) return;

  const hasExterior = spinPayload?.skuDetails?.length > 0;
  const hasInterior =
    Array.isArray(spinPayload?.interior360Data) &&
    spinPayload.interior360Data.length > 0;

  if (spin360.showExterior && hasExterior) {
    mediaData["360"] = spinPayload;
  }
  if (spin360.showInterior && hasInterior) {
    mediaData["360Int"] = spinPayload.interior360Data;
  }
};
